<script setup lang="ts">
// Vendor
import type { InvalidSubmissionContext } from "vee-validate";

// Types
import type { DefaultForm, TSchema } from "../types/baseform";

const { initialErrors, initialValues, validationSchema } =
  defineProps<DefaultForm<TSchema>>();

const emit = defineEmits<{
  (event: "submit", values: Partial<TSchema>): void;
  (event: "error", payload: InvalidSubmissionContext): void;
}>();

const { handleSubmit, values } = useForm<Partial<TSchema>>({
  initialErrors,
  initialValues,
  validationSchema,
});

const _onSubmit = handleSubmit(
  (values) => emit("submit", values),
  (payload) => emit("error", payload),
);

defineExpose({
  values,
});
</script>

<template>
  <form class="default-form" @submit.prevent="_onSubmit">
    <slot />
  </form>
</template>
